import {API, Setup} from '../../Services';


async function getOnline_api(page=1){
    const token = localStorage.getItem('token')
    return API.get(`/orders/?page=${page}`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function getOffline_api(page){
    const token = localStorage.getItem('token')
    return API.get(`/payments/invoices?is_online_shop=false/?page=${page}`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}


export {getOnline_api,getOffline_api};
